import { appApiHeaders, getApiUrl } from '@/utils/api-utils'
import { apiCall } from '@ngtrvu/use-api'

const FETCH_STAFF_MEMBERS = 'FETCH_STAFF_MEMBERS'
const FETCH_PENDING_INVITATIONS = 'FETCH_PENDING_INVITATIONS'
const FETCH_AUTHOR_PROFILE = 'FETCH_AUTHOR_PROFILE'
const FETCH_AUTHOR_PROFILES = 'FETCH_AUTHOR_PROFILES'

export const getStaffMembersApi = apiCall(
  FETCH_STAFF_MEMBERS,
  ({ siteId }: { siteId: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/staff`),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)

export const getPendingInvitationsApi = apiCall(
  FETCH_PENDING_INVITATIONS,
  ({ siteId }: { siteId: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/invitations/sites/${siteId}`),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)

export const getAuthorProfileApi = apiCall(
  FETCH_AUTHOR_PROFILE,
  ({ siteId, userId }: { siteId: string; userId: string }) => ({
    endpoint: getApiUrl(
      `/api/cms/v1/sites/${siteId}/author-profiles/${userId}`,
    ),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)

export const getAuthorProfilesApi = apiCall(
  FETCH_AUTHOR_PROFILES,
  ({ siteId }: { siteId: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/author-profiles`),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)

const FETCH_MY_ROLE = 'FETCH_MY_ROLE'

export const getMyRoleApi = apiCall(
  FETCH_MY_ROLE,
  ({ siteId }: { siteId: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/sites/${siteId}/staff/me`),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)

const FETCH_INVITATION_DETAILS = 'FETCH_INVITATION_DETAILS'

export const getInvitationDetailsApi = apiCall(
  FETCH_INVITATION_DETAILS,
  ({ token }: { token: string }) => ({
    endpoint: getApiUrl(`/api/cms/v1/account/invitations/${token}`),
    method: 'GET',
    headers: appApiHeaders(),
  }),
)
